const stageFromInterview = (stage) => stage === "final" ? 3 : 2;

export function skippedStageIndexes(events = [], application = null) {
  const indexes = { assessment: 1, initial_interview: 2, final_interview: 3 };
  const skipped = new Set(events.filter((event) => event.event_type === "hiring_step_skipped")
    .map((event) => indexes[String(event.detail || "").split(":")[0].trim()])
    .filter((index) => index !== undefined));
  if (application?.source === "direct_hire") [1, 2, 3].forEach((index) => skipped.add(index));
  return skipped;
}

// Events arrive newest first. The event immediately before rejection tells us
// where the application stopped; later stages were never reached.
export function rejectionStageIndex(application, events = [], interviews = [], assessment = null) {
  if (application?.status !== "rejected") return null;
  const rejectionEventIndex = events.findIndex((event) => event.event_type === "rejected");
  const precedingEvents = rejectionEventIndex < 0 ? events : events.slice(rejectionEventIndex + 1);
  for (const event of precedingEvents) {
    const type = event.event_type;
    if (type === "rejection_stage") {
      const stage = String(event.detail || "");
      if (stage === "selected") return 4;
      if (stage === "final_interview") return 3;
      if (stage === "initial_interview" || stage === "interview") return 2;
      if (stage === "assessment" || stage === "screening") return 1;
      return 0;
    }
    if (type === "selected" || type === "direct_hire_started" || type.startsWith("candidate_") || type.startsWith("employee_")) return 4;
    if (type === "final_interview") return 3;
    if (type === "initial_interview") return 2;
    if (type === "interview_scheduled" || type === "interview_completed") {
      const stage = String(event.detail || "").split(":")[0];
      return stageFromInterview(stage);
    }
    if (type === "interview_cancelled") {
      const interview = interviews.find((item) => String(item.id) === String(event.detail));
      if (interview) return stageFromInterview(interview.stage);
    }
    if (type.startsWith("assessment_") || type === "assessment") return 1;
    if (type === "screening") return 1;
    if (type === "interview") return 2;
    if (type === "applied") return 0;
  }
  if (application?.candidate_onboarding_status) return 4;
  if (interviews.some((item) => item.stage === "final")) return 3;
  if (interviews.length) return 2;
  if (assessment) return 1;
  return 0;
}
